import React, { useState, useEffect, useContext } from "react";
import {
  Box,
  Paper,
  Typography,
  Grid,
  Button,
  IconButton,
} from "@mui/material";
import { AppDataContext } from "../../../common/appContext";
import JWPlayer from "./../../../sharedComponents/JWPlayer/JWPlayer";
import PlayerImg from "../../../images/novideo.png";
import { Video_baseUrl } from "../../../services/AzureStorage";
import { makeStyles } from "@mui/styles";
import { PlayerProfileService } from "../../../services/playerProfile.Service";
import shooting from "../../../icons/icons-NBAblue/shooting.png";
import PrimaryVideoImage from "../../../images/C3_B.png";
import SecondaryVideoImage from "../../../images/C3_G.png";
import CustomTooltip from "../../../common/CustomTooltip";
import VideoJS from "../../../sharedComponents/videoPlayer/VideoJS";

const useStyles = makeStyles((theme) => ({
  mainContent: {
    // "& .jwplayer": {
    //     width: "450px !important",
    //     height: "220px !important",
    //   },
    // display: "flex",
    // justifyContent: "center",
  },
  subtitle: {
    fontWeight: "500",
  },
  paperStyle: {
    margin: "5px",
    padding: "5px",
  },
  btnselected: {
    backgroundColor: "#C8102E", //"#1d428a",
    color: "#fff",
    marginRight: theme.spacing(1),
    "&:hover": {
      backgroundColor: "#C8102E",
    },
  },
  btnunselected: {
    backgroundColor: "#707070",
    color: "#fff",
    marginRight: theme.spacing(1),
    "&:hover": {
      backgroundColor: "#707070",
    },
  },
}));

export default function SituationalWorkouts(props) {
  const { playerID, setLoading } = props;
  const { selectedEventId, user } = useContext(AppDataContext);
  const [eventId, setEventId] = useState(selectedEventId);
  const [contestShooting, setcontestShooting] = useState([]);
  const [threetwodata, setthreetwoData] = useState([]);
  const [fourvfour, setfourvfour] = useState([]);
  const [playerYear, setplayerYear] = useState([{}]);
  const [btn1, setbtn1] = useState(false);
  const [btn2, setbtn2] = useState(false);
  const [btn3, setbtn3] = useState(false);
  const [btn4, setbtn4] = useState(false);
  const [btn5, setbtn5] = useState(false);
  async function loadContestShooting() {
    try {
      setLoading(true);
      let response1 = await PlayerProfileService.getFullcourtAndWorkoutVideos(
        eventId,
        501,
        playerID
      );
      setcontestShooting(
        [...response1.data].map((v) => ({
          ...v,
          videoAngleFlag: 0,
        }))
      );
    } finally {
      setLoading(false);
    }
  }
  async function loadthreeTwoData() {
    try {
      setLoading(true);
      let response1 = await PlayerProfileService.getFullcourtAndWorkoutVideos(
        eventId,
        502,
        playerID
      );
      setthreetwoData(
        [...response1.data].map((v) => ({
          ...v,
          videoAngleFlag: 0,
        }))
      );
    } finally {
      setLoading(false);
    }
  }
  async function loadFOurVFour() {
    try {
      setLoading(true);
      let response = await PlayerProfileService.getFullcourtAndWorkoutVideos(
        eventId,
        503,
        playerID
      );
      setfourvfour(
        [...response.data].map((v) => ({
          ...v,
          videoAngleFlag: 0,
        }))
      );
    } finally {
      setLoading(false);
    }
  }
  async function loadContestShootingYearData(eventYearID) {
    try {
      setLoading(true);
      let response1 = await PlayerProfileService.getFullcourtAndWorkoutVideos(
        eventYearID,
        501,
        playerID
      );
      setcontestShooting(
        [...response1.data].map((v) => ({
          ...v,
          videoAngleFlag: 0,
        }))
      );
    } finally {
      setLoading(false);
    }
  }
  async function loadthreeTwoDataYearData(eventYearID) {
    try {
      setLoading(true);
      let response1 = await PlayerProfileService.getFullcourtAndWorkoutVideos(
        eventYearID,
        502,
        playerID
      );
      setthreetwoData(
        [...response1.data].map((v) => ({
          ...v,
          videoAngleFlag: 0,
        }))
      );
    } finally {
      setLoading(false);
    }
  }
  async function loadFOurVFourYearData(eventYearID) {
    try {
      setLoading(true);
      let response = await PlayerProfileService.getFullcourtAndWorkoutVideos(
        eventYearID,
        503,
        playerID
      );
      setfourvfour(
        [...response.data].map((v) => ({
          ...v,
          videoAngleFlag: 0,
        }))
      );
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    setEventId(selectedEventId);
  }, [selectedEventId]);
  useEffect(() => {
    setbtn1(false);
    setbtn2(false);
    setbtn3(false);
    setbtn4(false);
    setbtn5(false);
    loadContestShooting();
    loadthreeTwoData();
    loadFOurVFour();

    PlayerProfileService.getAnthrosDataByPlayerYear(eventId, playerID).then(
      (response) => {
        //console.log("setCombineYearDropdownData ", response.data);

        setplayerYear(response.data);
        var pdata = response.data;
        pdata.map((item, index) => {
          if (item.eventId === eventId && index == 0) {
            setbtn1(true); //btn1=true;
          } else if (item.eventId === selectedEventId && index == 1) {
            setbtn2(true); // btn2=true;
          } else if (item.eventId === eventId && index == 2) {
            setbtn3(true); // btn2=true;
          } else if (item.eventId === eventId && index == 3) {
            setbtn4(true); //btn4=true;
          } else if (item.eventId === eventId && index == 4) {
            setbtn5(true); // btn5=true;
          }
        });
        // console.log("Player Years", response.data);
      }
    );
  }, [eventId]);
  const getyearValue = (playerEventId, index) => {
    if (index === 0) {
      setbtn1(true);
      setbtn2(false);
      setbtn3(false);
      setbtn4(false);
      setbtn5(false);
      //  btn1=true;btn2=false;btn3=false;btn4=false;btn5=false;
    } else if (index === 1) {
      setbtn1(false);
      setbtn2(true);
      setbtn3(false);
      setbtn4(false);
      setbtn5(false); //btn1=false;btn2=true;btn3=false;btn4=false;btn5=false;
    } else if (index === 2) {
      setbtn1(false);
      setbtn2(false);
      setbtn3(true);
      setbtn4(false);
      setbtn5(false); //btn1=false;btn2=false;btn3=true;btn4=false;btn5=false;
    } else if (index === 3) {
      setbtn1(false);
      setbtn2(false);
      setbtn3(false);
      setbtn4(true);
      setbtn5(false); //btn1=false;btn2=false;btn3=false;btn4=true;btn5=false;
    } else if (index === 4) {
      setbtn1(false);
      setbtn2(false);
      setbtn3(false);
      setbtn4(false);
      setbtn5(true); // btn1=false;btn2=false;btn3=false;btn4=false;btn5=true;
    }

    loadContestShootingYearData(playerEventId);
    loadthreeTwoDataYearData(playerEventId);
    loadFOurVFourYearData(playerEventId);
  };

  const classes = useStyles();

  const handleVideoAngleClick = (
    videoID,
    videoAngleType,
    stateHolder,
    stateUpdator
  ) => {
    // console.log("videoAngleType", videoAngleType);
    // console.log("videoID", videoID);

    const newVideoArray = stateHolder.map((video, index) => {
      if (index === videoID) {
        video.videoAngleFlag = videoAngleType;
      }

      return video;
    });

    stateUpdator(newVideoArray);
  };

  return (
    <>
      <Box
        display="flex"
        alignItems={"center"}
        justifyContent="center"
        mt={1}
        mb={1}
      >
        {playerYear.length > 1
          ? playerYear.map((item, index) => {
              if (index === 0) {
                return (
                  <>
                    <Typography
                      variant="h6"
                      fontStyle="italic"
                      mr={2}
                      color={"primary"}
                    >
                      Details available for{" "}
                    </Typography>
                    <Button
                      onClick={() => getyearValue(item.eventId, index)}
                      key={index}
                      className={
                        btn1 === true
                          ? classes.btnselected
                          : classes.btnunselected
                      }
                    >
                      Year {item.eventYear}
                    </Button>
                  </>
                );
              } else if (index === 1) {
                return (
                  <Button
                    onClick={() => getyearValue(item.eventId, index)}
                    key={index}
                    className={
                      btn2 === true
                        ? classes.btnselected
                        : classes.btnunselected
                    }
                  >
                    Year {item.eventYear}
                  </Button>
                );
              } else if (index === 2) {
                return (
                  <Button
                    onClick={() => getyearValue(item.eventId, index)}
                    key={index}
                    className={
                      btn3 === true
                        ? classes.btnselected
                        : classes.btndeselected
                    }
                  >
                    Year {item.eventYear}
                  </Button>
                );
              } else if (index === 3) {
                return (
                  <Button
                    onClick={() => getyearValue(item.eventId, index)}
                    key={index}
                    className={
                      btn4 === true
                        ? classes.btnselected
                        : classes.btnunselected
                    }
                  >
                    Year {item.eventYear}
                  </Button>
                );
              } else if (index === 4) {
                return (
                  <Button
                    onClick={() => getyearValue(item.eventId, index)}
                    key={index}
                    className={
                      btn5 === true
                        ? classes.btnselected
                        : classes.btnunselected
                    }
                  >
                    Year {item.eventYear}
                  </Button>
                );
              } else {
                return (
                  <Button
                    onClick={() => getyearValue(item.eventId, index)}
                    key={index}
                    className={
                      btn5 === true
                        ? classes.btnselected
                        : classes.btnunselected
                    }
                  >
                    {item.eventYear}
                  </Button>
                );
              }
            })
          : ""}
      </Box>
      <Paper elevation={5} className={classes.paperStyle}>
        <Box display="flex" justifyContent="center">
          <img
            alt="Contested-Shooting-icon"
            src={shooting}
            height={30}
            width={30}
            style={{
              marginRight: "5px",
            }}
          />
          <Typography
            noWrap
            color="primary"
            variant="subtitle1"
            className={classes.subtitle}
            sx={{ marginTop: "-5px", fontSize: "25px" }}
          >
            Live Action
          </Typography>
        </Box>

        <Box sx={{ margin: "15px 0px 10px 5px" }}>
          <Grid container justifyContent={"center"} spacing={5}>
            {contestShooting.length > 0 ? (
              contestShooting.map((val, index) => {
                //#Extract thumbnail
                const primaryImageVideo = val.jsonData
                  ? JSON.parse(val.jsonData).thumbnail
                  : "";
                const secondaryImageVideo = val.secondaryJsonData
                  ? JSON.parse(val.secondaryJsonData).thumbnail
                  : "";

                return (
                  <Grid
                    item
                    lg={5}
                    md={12}
                    sm={12}
                    xs={12}
                    justifyContent="center"
                    display="flex"
                  >
                    <Paper
                      mt={2}
                      sx={{
                        padding: "10px",
                        // border: "2px solid lightgrey",
                        // borderRadius: "5px",
                      }}
                      className={classes.mainContent}
                      elevation={2}
                    >
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        sx={{ my: 1 }}
                      >
                        <IconButton
                          size="small"
                          onClick={() =>
                            handleVideoAngleClick(
                              index,
                              0,
                              contestShooting,
                              setcontestShooting
                            )
                          }
                          sx={{
                            backgroundColor:
                              val.videoAngleFlag === 0
                                ? "rgba(29, 66, 138, 0.2)"
                                : "",
                          }}
                        >
                          <CustomTooltip title="Primary Video" placement="top">
                            <img
                              alt="Primary Video"
                              src={
                                val.videoAngleFlag === 0
                                  ? PrimaryVideoImage
                                  : SecondaryVideoImage
                              }
                              width="30"
                              height="30"
                            />
                          </CustomTooltip>
                        </IconButton>
                        <IconButton
                          size="small"
                          onClick={() =>
                            handleVideoAngleClick(
                              index,
                              1,
                              contestShooting,
                              setcontestShooting
                            )
                          }
                          sx={{
                            backgroundColor:
                              val.videoAngleFlag === 1
                                ? "rgba(29, 66, 138, 0.2)"
                                : "",
                          }}
                        >
                          <CustomTooltip
                            title="Secondary Video"
                            placement="top"
                          >
                            <img
                              alt="Secondary Video"
                              src={
                                val.videoAngleFlag === 1
                                  ? PrimaryVideoImage
                                  : SecondaryVideoImage
                              }
                              width="30"
                              height="30"
                            />
                          </CustomTooltip>
                        </IconButton>
                      </Box>

                      {val.videoAngleFlag === 0 ? (
                        <Box mt={1}>
                          {val.videoFileName === null ||
                          val.videoFileName === "" ? (
                            <img
                              alt="no-video-found"
                              src={PlayerImg}
                              className="noVideoImage"
                            />
                          ) : (
                            <VideoJS
                              fileURL={Video_baseUrl(val.videoFileName)}
                              isAutoplay={false}
                              id={"contestedshooting" + index}
                              image={Video_baseUrl(primaryImageVideo)}
                              fileName={val.videoFileName}
                              isSlowMo={true}
                              isDownload={true}
                            />
                          )}
                        </Box>
                      ) : null}

                      {val.videoAngleFlag === 1 ? (
                        <Box mt={1}>
                          {val.secondaryVideoFileName === null ||
                          val.secondaryVideoFileName === "" ? (
                            <img
                              alt="no-video-found"
                              src={PlayerImg}
                              className="noVideoImage"
                            />
                          ) : (
                            <VideoJS
                              fileURL={Video_baseUrl(
                                val.secondaryVideoFileName
                              )}
                              isAutoplay={false}
                              id={"contestedshooting" + index}
                              image={Video_baseUrl(secondaryImageVideo)}
                              fileName={val.secondaryVideoFileName}
                              isSlowMo={true}
                              isDownload={true}
                            />
                          )}
                        </Box>
                      ) : null}
                    </Paper>
                  </Grid>
                );
              })
            ) : (
              <Grid item lg={5} md={12} sm={12} xs={12}>
                <Box
                  mt={2}
                  sx={{
                    padding: "10px",
                    // border: "2px solid lightgrey",
                    // borderRadius: "5px",
                  }}
                >
                  <Box
                    mt={1}
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <img
                      alt="no-video-found"
                      src={PlayerImg}
                      className="noVideoImage"
                    />
                  </Box>
                </Box>
              </Grid>
            )}
          </Grid>
        </Box>
      </Paper>

      {/* <Paper elevation={5} className={classes.paperStyle}>
        <Box display="flex" justifyContent="center">
          <img
            alt="Contested-Shooting-icon"
            src={shooting}
            height={30}
            width={30}
            style={{
              marginRight: "5px",
            }}
          />
          <Typography
            noWrap
            color="primary"
            variant="subtitle1"
            className={classes.subtitle}
            sx={{ marginTop: "-5px", fontSize: "25px" }}
          >
            3 On 2/2 On 1/1 On 1
          </Typography>
        </Box>

        <Box sx={{ my: 2 }}>
          <Grid container justifyContent={"center"} spacing={5}>
            {threetwodata.length > 0 ? (
              threetwodata.map((val, index) => {
                //#Extract thumbnail
                const primaryImageVideo = val.jsonData
                  ? JSON.parse(val.jsonData).thumbnail
                  : "";
                const secondaryImageVideo = val.secondaryJsonData
                  ? JSON.parse(val.secondaryJsonData).thumbnail
                  : "";

                return (
                  <Grid
                    item
                    lg={5}
                    md={12}
                    sm={12}
                    xs={12}
                    justifyContent="center"
                    display="flex"
                  >
                    <Paper
                      mt={2}
                      sx={{
                        padding: "10px",
                        // border: "2px solid lightgrey",
                        // borderRadius: "5px",
                      }}
                      className={classes.mainContent}
                      elevation={2}
                    >
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        sx={{ my: 1 }}
                      >
                        <IconButton
                          size="small"
                          onClick={() =>
                            handleVideoAngleClick(
                              index,
                              0,
                              threetwodata,
                              setthreetwoData
                            )
                          }
                          sx={{
                            backgroundColor:
                              val.videoAngleFlag === 0
                                ? "rgba(29, 66, 138, 0.2)"
                                : "",
                          }}
                        >
                          <CustomTooltip title="Primary Video" placement="top">
                            <img
                              alt="Primary Video"
                              src={
                                val.videoAngleFlag === 0
                                  ? PrimaryVideoImage
                                  : SecondaryVideoImage
                              }
                              width="30"
                              height="30"
                            />
                          </CustomTooltip>
                        </IconButton>
                        <IconButton
                          size="small"
                          onClick={() =>
                            handleVideoAngleClick(
                              index,
                              1,
                              threetwodata,
                              setthreetwoData
                            )
                          }
                          sx={{
                            backgroundColor:
                              val.videoAngleFlag === 1
                                ? "rgba(29, 66, 138, 0.2)"
                                : "",
                          }}
                        >
                          <CustomTooltip
                            title="Secondary Video"
                            placement="top"
                          >
                            <img
                              alt="Secondary Video"
                              src={
                                val.videoAngleFlag === 1
                                  ? PrimaryVideoImage
                                  : SecondaryVideoImage
                              }
                              width="30"
                              height="30"
                            />
                          </CustomTooltip>
                        </IconButton>
                      </Box>

                      {val.videoAngleFlag === 0 ? (
                        <Box mt={1}>
                          {val.videoFileName === null ||
                          val.videoFileName === "" ? (
                            <img
                              alt="no-video-found"
                              src={PlayerImg}
                              className="noVideoImage"
                            />
                          ) : (
                            <JWPlayer
                              fileURL={Video_baseUrl(val.videoFileName)}
                              isAutoplay={false}
                              id={"threeOnTwoVideoData" + index}
                              image={Video_baseUrl(primaryImageVideo)}
                              fileName={val.videoFileName}
                              isSlowMo={true}
                              isDownload={true}
                            />
                          )}
                        </Box>
                      ) : null}

                      {val.videoAngleFlag === 1 ? (
                        <Box mt={1}>
                          {val.secondaryVideoFileName === null ||
                          val.secondaryVideoFileName === "" ? (
                            <img
                              alt="no-video-found"
                              src={PlayerImg}
                              className="noVideoImage"
                            />
                          ) : (
                            <JWPlayer
                              fileURL={Video_baseUrl(
                                val.secondaryVideoFileName
                              )}
                              isAutoplay={false}
                              id={"threeOnTwoVideoData" + index}
                              image={Video_baseUrl(secondaryImageVideo)}
                              fileName={val.secondaryVideoFileName}
                              isSlowMo={true}
                              isDownload={true}
                            />
                          )}
                        </Box>
                      ) : null}
                    </Paper>
                  </Grid>
                );
              })
            ) : (
              <Grid item lg={5} md={12} sm={12} xs={12}>
                <Box
                  mt={2}
                  sx={{
                    padding: "10px",
                    // border: "2px solid lightgrey",
                    // borderRadius: "5px",
                  }}
                  className={classes.mainContent}
                >
                  <Box mt={1}>
                    <img
                      alt="no-video-found"
                      src={PlayerImg}
                      className="noVideoImage"
                    />
                  </Box>
                </Box>
              </Grid>
            )}
          </Grid>
        </Box>
      </Paper>

      <Paper elevation={5} className={classes.paperStyle}>
        <Box display="flex" justifyContent="center">
          <img
            alt="4vs4HalfCourt-icon"
            src={shooting}
            height={30}
            width={30}
            style={{
              marginRight: "5px",
            }}
          />
          <Typography
            noWrap
            color="primary"
            variant="subtitle1"
            className={classes.subtitle}
            sx={{ marginTop: "-5px", fontSize: "25px" }}
          >
            4 vs 4 Half Court
          </Typography>
        </Box>

        <Box sx={{ my: 2 }}>
          <Grid container justifyContent={"center"} spacing={5}>
            {fourvfour.length > 0 ? (
              fourvfour.map((val, index) => {
                //#Extract thumbnail
                const primaryImageVideo = val.jsonData
                  ? JSON.parse(val.jsonData).thumbnail
                  : "";
                const secondaryImageVideo = val.secondaryJsonData
                  ? JSON.parse(val.secondaryJsonData).thumbnail
                  : "";

                return (
                  <Grid
                    item
                    lg={5}
                    md={12}
                    sm={12}
                    xs={12}
                    justifyContent="center"
                    display="flex"
                  >
                    <Paper
                      mt={2}
                      sx={{
                        padding: "10px",
                        // border: "2px solid lightgrey",
                        // borderRadius: "5px",
                      }}
                      className={classes.mainContent}
                      elevation={2}
                    >
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        sx={{ my: 1 }}
                      >
                        <IconButton
                          size="small"
                          onClick={() =>
                            handleVideoAngleClick(
                              index,
                              0,
                              fourvfour,
                              setfourvfour
                            )
                          }
                          sx={{
                            backgroundColor:
                              val.videoAngleFlag === 0
                                ? "rgba(29, 66, 138, 0.2)"
                                : "",
                          }}
                        >
                          <CustomTooltip title="Primary Video" placement="top">
                            <img
                              alt="Primary Video"
                              src={
                                val.videoAngleFlag === 0
                                  ? PrimaryVideoImage
                                  : SecondaryVideoImage
                              }
                              width="30"
                              height="30"
                            />
                          </CustomTooltip>
                        </IconButton>
                        <IconButton
                          size="small"
                          onClick={() =>
                            handleVideoAngleClick(
                              index,
                              1,
                              fourvfour,
                              setfourvfour
                            )
                          }
                          sx={{
                            backgroundColor:
                              val.videoAngleFlag === 1
                                ? "rgba(29, 66, 138, 0.2)"
                                : "",
                          }}
                        >
                          <CustomTooltip
                            title="Secondary Video"
                            placement="top"
                          >
                            <img
                              alt="Secondary Video"
                              src={
                                val.videoAngleFlag === 1
                                  ? PrimaryVideoImage
                                  : SecondaryVideoImage
                              }
                              width="30"
                              height="30"
                            />
                          </CustomTooltip>
                        </IconButton>
                      </Box>

                      {val.videoAngleFlag === 0 ? (
                        <Box mt={1}>
                          {val.videoFileName === null ||
                          val.videoFileName === "" ? (
                            <img
                              alt="no-video-found"
                              src={PlayerImg}
                              className="noVideoImage"
                            />
                          ) : (
                            <JWPlayer
                              fileURL={Video_baseUrl(val.videoFileName)}
                              isAutoplay={false}
                              id={"4vs4HalfCourt" + index}
                              image={Video_baseUrl(primaryImageVideo)}
                              fileName={val.videoFileName}
                              isSlowMo={true}
                              isDownload={true}
                            />
                          )}
                        </Box>
                      ) : null}

                      {val.videoAngleFlag === 1 ? (
                        <Box mt={1}>
                          {val.secondaryVideoFileName === null ||
                          val.secondaryVideoFileName === "" ? (
                            <img
                              alt="no-video-found"
                              src={PlayerImg}
                              className="noVideoImage"
                            />
                          ) : (
                            <JWPlayer
                              fileURL={Video_baseUrl(
                                val.secondaryVideoFileName
                              )}
                              isAutoplay={false}
                              id={"4vs4HalfCourt" + index}
                              image={Video_baseUrl(secondaryImageVideo)}
                              fileName={val.secondaryVideoFileName}
                              isSlowMo={true}
                              isDownload={true}
                            />
                          )}
                        </Box>
                      ) : null}
                    </Paper>
                  </Grid>
                );
              })
            ) : (
              <Grid item lg={5} md={12} sm={12} xs={12}>
                <Box
                  mt={2}
                  sx={{
                    padding: "10px",
                    // border: "2px solid lightgrey",
                    // borderRadius: "5px",
                  }}
                  className={classes.mainContent}
                >
                  <Box mt={1}>
                    <img
                      alt="no-video-found"
                      src={PlayerImg}
                      className="noVideoImage"
                    />
                  </Box>
                </Box>
              </Grid>
            )}
          </Grid>
        </Box>
      </Paper> */}
    </>
  );
}
